import React from 'react';
import { HStack, Stack, Text, useColorModeValue } from '@chakra-ui/react';
import PaymentComponent from '../Payment/PaymentComponent';
import {
  Progress,
  Box,
  ButtonGroup,
  Button,
  Heading,
  Flex,
  FormControl,
  GridItem,
  FormLabel,
  Input,
  Select,
  SimpleGrid,
  InputLeftAddon,
  InputGroup,
  Textarea,
  FormHelperText,
  InputRightElement,
  VStack,
  List,
  ListItem,
} from '@chakra-ui/react';
import { Card, CardHeader, CardBody, CardFooter } from '@chakra-ui/react';
import { Divider } from 'antd';
import { ArrowBackIcon, ArrowForwardIcon } from '@chakra-ui/icons';
import { Link } from 'react-router-dom';

export default function OrderSummary() {
  return (
    <>
      <Flex
        minH={'100vh'}
        align={'center'}
        justify={'center'}
        bg={useColorModeValue('gray.50', 'gray.800')}
      >
        <Stack spacing={8} mx={'auto'} minW={'70%'} py={12} px={6}>
          <Stack align={'center'}>
            <Heading fontSize={'4xl'} textAlign={'center'}>
              Confirm order details
            </Heading>
            <Text fontSize={'lg'} color={'gray.600'}>
              Confirm your order details and proceed to ment 📃
            </Text>
          </Stack>
          <Box
            rounded={'lg'}
            bg={useColorModeValue('white', 'gray.700')}
            boxShadow={'lg'}
            p={8}
          >
            <VStack alignItems={'left'}>
              <Heading>Service Type</Heading>
              <Text>SOP Review</Text>
            </VStack>
            <Divider />

            <VStack alignItems={'left'}>
              <SimpleGrid
                columns={{ base: 2, md: 2 }}
                spacing={{ base: 20, md: 5 }}
                maxWidth={{ base: '100%', md: '50%' }}
              >
                <List spacing={2}>
                  <ListItem>SOP Type</ListItem>
                  <ListItem>Pages/Words</ListItem>{' '}
                  <ListItem>College</ListItem>
                  <ListItem>Language</ListItem>
                  <ListItem>Deadline</ListItem>
                </List>
                <List spacing={2}>
                  <ListItem>Full Review</ListItem>
                  <ListItem>275</ListItem>
                  <ListItem>Atlanta University, USA</ListItem>
                  <ListItem>English</ListItem>
                  <ListItem>02-05-23</ListItem>
                </List>
              </SimpleGrid>
            </VStack>
            <Divider />
            <Box>
              <HStack justify="flex-end">
                <Heading size={'md'}>Estimated price:</Heading>
                <Text>$9.97</Text>
              </HStack>
            </Box>
          </Box>

          <Box>
            <HStack justify="flex-end">
              <Link to="/OurProducts">
                <Button
                  colorScheme="blue"
                  leftIcon={<ArrowBackIcon />}
                  variant="outline"
                >
                  Back
                </Button>
              </Link>

              {/* <PaymentComponent /> */}

              <Button
                colorScheme="blue"
                rightIcon={<ArrowForwardIcon />}
                variant="solid"
              >
                Proceed to Payment
              </Button>
            </HStack>
          </Box>
        </Stack>
      </Flex>
    </>
  );
}
